export const PAGE_TRACKING_APPLICATION_NAME = 'facilita-app';

export const PAGE_TRACKING_EXCLUDE_ATTRIBUTE = 'data-tracking-exclude';

export const pageTrackingExcludeProps = { [PAGE_TRACKING_EXCLUDE_ATTRIBUTE]: 'true' };
